import { AfterViewInit, Component, inject } from '@angular/core';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../mask/mask.component';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { MenuItem, MessageService, PrimeTemplate } from 'primeng/api';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { TableCaptionComponent } from '../../molecules/table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../../molecules/table-list-actions/table-list-actions.component';
import { TableModule } from 'primeng/table';
import { BaseListComponent } from '../base-list/base-list.component';
import { Image } from '../../../models/image';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { ImageStore } from '../../../stores/image/image.state';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { DividerModule } from 'primeng/divider';
import { getUploadPath } from '../../../utility/app.utility';
import { ImageService } from '../../../services/image/image.service';

@Component({
  selector: 'app-image-pool',
  standalone: true,
  imports: [
    AlertComponent,
    HeaderComponent,
    MaskComponent,
    NgIf,
    PrimeTemplate,
    RouterOutlet,
    SidebarModule,
    TableCaptionComponent,
    TableListActionsComponent,
    TableModule,
    RouterLink,
    DividerModule,
    NgOptimizedImage,
  ],
  templateUrl: './image-pool.component.html',
  styleUrl: './image-pool.component.scss',
})
export class ImagePoolComponent
  extends BaseListComponent<Image>
  implements AfterViewInit
{
  readonly store = inject(ImageStore);
  readonly activeUserStore = inject(ActiveUserStore);
  override menuItems: MenuItem[] = [];
  override sidebarId = 'image-administration';

  constructor(
    protected sidebarService: SidebarService,
    protected imageService: ImageService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }

  getSrc(src: string): string {
    return getUploadPath(`imagePool/${this.activeUserStore.commune()}`, src);
  }

  ngAfterViewInit(): void {
    return;
  }

  override remove = (item: Image) => {
    this.imageService.removeImageSrc(item.src, this.activeUserStore.commune());
    this.store.deleteItem(item);
    this.store.deselect();
  };
}
